export default "__VITE_ASSET__a51bd1a1__"